import styled, { css } from "styled-components";
import { ModuleLayoutStyle } from "../../../../services/playground";

export interface ProductCardWrapProps {
	// 格式: 12px or calc(**)
	width: string | number;
}
export const ProductCardWrap = styled.a.withConfig({
	shouldForwardProp: (prop) => !["width"].includes(prop),
})<ProductCardWrapProps>`
	display: flex;
	flex-direction: column;
	background-color: white;
	box-sizing: border-box;
	position: relative;
	transition: all 0.3s ease;
	text-decoration: none;
	border-radius: 4px;
	overflow: hidden;
	cursor: pointer;

	${(props: ProductCardWrapProps) => {
		if (typeof props.width === "number" || !isNaN(+props.width)) {
			return css`
				width: ${props.width}px;
			`;
		}
		return css`
			width: ${props.width || "291px"};
		`;
	}}

	&:hover {
		border-color: #eaeaea;
		-webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		text-decoration: none;

		& > .image:after {
			background-color: rgba(255, 255, 255, 0.1);
		}
	}
`;
interface ProductCardPosterProps {
	posterRatio: number;
	layoutStyle: ModuleLayoutStyle;
}
export const ProductCardPoster = styled.section.withConfig({
	shouldForwardProp: (prop) => !["layoutStyle", "posterRatio"].includes(prop),
})<ProductCardPosterProps>`
	width: 100%;
	position: relative;
	display: block;
	background: #fff;

	${(props: ProductCardPosterProps) => {
		if (props.posterRatio) {
			const gap = `calc(${props.posterRatio} * 100%)`;
			return css`
				padding-bottom: ${gap};
			`;
		}
		return css`
			padding-bottom: 100%;
		`;
	}}

	&:after {
		content: "";
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		transition: all 0.3s ease;
	}

	.productImage {
		position: absolute;
		z-index: 0;
		left: 0;
		top: 0;
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
export interface DescriptionWrapProps {
	gridCol: number;
}
export const DescriptionWrap = styled.section.withConfig({
	shouldForwardProp: (prop) => !["gridCol"].includes(prop),
})<DescriptionWrapProps>`
	padding: 8px;
	display: flex;
	flex-direction: column;
	flex: 1 auto;
	gap: 5px;

	html[dir="rtl"] & {
		& > p {
			direction: rtl;
		}
		& > div.currentPrice {
			text-align: right;
		}
	}

	/* ${(props: DescriptionWrapProps) => {
		const gridCol = props.gridCol;
		if (gridCol === 5) {
			return css`
				& > p {
					font-size: 12px;
					line-height: 16px;
				}
			`;
		}
		return css``;
	}} */
`;
